import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table, TableBody, TableCell,
  TableContainer,
  TableHead, TableRow
} from "@mui/material";
import type { ISpecData } from "./types";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import { hasSpaceOrSpecialCharAtEnd, hasSpaceOrSpecialCharAtStart } from "./utils";


interface IProps {
  categories: ISpecData[];
  onApply: () => void;
  onCancel: () => void;
}

const headerStyle = {
  backgroundColor: "rgba(0, 0, 0, .1)",
}

const UpdateDialog = ({ onCancel, onApply, categories }: IProps): React.ReactElement => {

 return (
   <Dialog onClose={onCancel} open={true} maxWidth="md" >
     <DialogTitle style={{ background: "rgba(0, 0, 0, .2)" }}>
       Update Recipes
     </DialogTitle>
     <DialogContent dividers>
       <TableContainer component={Paper} style={{ maxHeight: 500 }} >
         <Table  size="small" stickyHeader>
           <TableHead>
             <TableRow>
               <TableCell style={{ ...headerStyle, width: 200 }}>Grade</TableCell>
               <TableCell style={{ ...headerStyle, width: 200 }}>Recipe</TableCell>
               <TableCell style={{ ...headerStyle, width: 100 }} align="right">Dolo</TableCell>
               <TableCell style={{ ...headerStyle, width: 100 }} align="right">Lime</TableCell>
             </TableRow>
           </TableHead>
           <TableBody>
             { categories.map((category, index) => {
               const fields = category.content?.fields || [];

               const doloValue = fields.find(field => field.name === "DOLO")?.value || 0;
               const hicalValue = fields.find(field => field.name === "HICAL")?.value || 0;
               const recipeValue = fields.find(field => field.name === "RECIPE")?.value || "";
               const hasSpecialChars = hasSpaceOrSpecialCharAtStart(category.name) || hasSpaceOrSpecialCharAtEnd(category.name);

               return (
                 <TableRow key={`row-${index}`} sx={{
                   backgroundColor: index % 2 === 0 ? "white" : "#f5f5f5", // Alternate row colors
                   '&:last-child td, &:last-child th': { border: 0 }
                 }}>
                   <TableCell>{hasSpecialChars ? `"${category.name}"` : category.name}</TableCell>
                   <TableCell>{recipeValue}</TableCell>
                   <TableCell align="right">{doloValue}</TableCell>
                   <TableCell align="right">{hicalValue}</TableCell>
                 </TableRow>
               );
             })}

           </TableBody>
         </Table>
       </TableContainer>



     </DialogContent>
     <DialogActions style={{ background: "rgba(0, 0, 0, .2)" }}>
       <Button autoFocus onClick={onApply} startIcon={<SaveAltIcon />} color="primary" >
         Apply
       </Button>
       <Button onClick={onCancel} startIcon={<CancelIcon />} color="error">
         Cancel
       </Button>
     </DialogActions>
   </Dialog>
 );
}

export default UpdateDialog;